export default __webpack_public_path__ + "static/media/define4.56d372ab.png";